module.exports = __webpack_public_path__ + "static/media/image20.baedd755.jpg";